import axios from '../helper/axios';
import {DEPARTMENT_URL} from '../constants/axios';
import {store} from '../store';
import {errorHandler} from '../helper/handlerAxios';
import {
    clearDepartmentForm,
    getAllDepartments,
} from '../actions/departments';
import {isEmpty} from "lodash";

export const getAllDepartmentsService = () => {
    const departments = store.getState().departments.departments;
    if (!isEmpty(departments)) return;

    axios
        .get(DEPARTMENT_URL)
        .then((response) => {
            store.dispatch(getAllDepartments(response.data));
        })
        .catch((error) => errorHandler(error));
};
